import Backbone from 'backbone';
import $ from 'jquery';

import ifCreateFromHash from 'util/ifCreateFromHash';

import BulkCreateInventoryFilesFlow from './BulkCreateInventoryFilesFlow';

class BulkImportLink extends Backbone.View<Backbone.Model> {
  render(): this {
    ifCreateFromHash('#import/inventory-files', (currentHash: string) => {
      BulkCreateInventoryFilesFlow.open({});
    });
    $(document).on('click', '.js-import-inventory-files', (e) => {
      e.preventDefault();
      BulkCreateInventoryFilesFlow.open({});
    });

    return this;
  }
}

export default BulkImportLink;
